import { environment } from "src/environments/environment";
export namespace NS_Enums {
    export const saras_global = `${environment.type}_global`
    export enum cacheKeysEnum {
      'user_details' = 'saras_user_details',
      'saras_user_id' = 'saras_user_id',
      'saras_auth_key' = 'saras_auth_key',
      'saras_custom_auth_key' = 'saras_custom_auth_key',
      'saras_global_portal' = 'saras_global_portal',
      'isEmailVerified' = 'isEmailVerified',
      'products' = 'products',
      'saras_mfa' = 'saras_mfa'
  }
  
  
    export enum callbackNameEnum {
      'deletedTablesMessage' = 'deletedTablesMessage',
      'formatDate' = 'formatDate',
      'getBillingCycle' = 'getBillingCycle',
      'getFromDescription' = 'getFromDescription',
      'showExpiryDays' = 'showExpiryDays',
      'getExpiryDays' = 'getExpiryDays'
    }

    export enum trackingCustomEvents{
      /* LOGIN */
      'LOGIN' = 'LOGIN',
      'LOGIN_PROTOTYPE' = 'LOGIN_PROTOTYPE',
      'LOGIN_ERROR' = 'LOGIN_ERROR',
      'LOGIN_LIMIT_EXCEEDED' = 'LOGIN_LIMIT_EXCEEDED',

      /* RESET */
      'RESET_LINK_SENT' = 'RESET_LINK_SENT',
      'RESET_LINK_SENT_FAILED' = 'RESET_LINK_SENT_FAILED',
      'RESET_RESEND_LINK' = 'RESET_RESEND_LINK',
      'RESET_RESEND_LINK_FAILED' = 'RESET_RESEND_LINK_FAILED',
      'RESET_USER_NOT_VERIFIED' = 'RESET_USER_NOT_VERIFIED',
      
      /* SIGNUP */
      'REGISTER_USER' = 'REGISTER_USER',
      'REGISTER_VERIFICATION_LINK_SENT' = 'REGISTER_VERIFICATION_LINK_SENT',
      'REGISTER_VERIFICATION_LINK_FAILED' = 'REGISTER_VERIFICATION_LINK_FAILED',
      'REGISTER_RESEND_VERIFICATION_LINK' = 'REGISTER_RESEND_VERIFICATION_LINK',
      'REGISTER_RESEND_VERIFICATION_LINK_FAILED' = 'REGISTER_RESEND_VERIFICATION_LINK_FAILED',
      'REGISTER_USER_ALREADY_EXISTS' = 'REGISTER_USER_ALREADY_EXISTS',

      /* PRODUCTS */
      'PRODUCT_REDIRECT' = 'PRODUCT_REDIRECT',
      'PRODUCT_DOCUMENT' = 'PRODUCT_DOCUMENT',
      'PRODUCT_KEY_FEATURE' = 'PRODUCT_KEY_FEATURE',
      'PRODUCT_SCEDULE' = 'PRODUCT_SCEDULE'
    }

    
    
}